import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FiSettings } from "react-icons/fi";
import { AiOutlineSchedule, AiOutlineFileSearch } from "react-icons/ai";
import { FaRegEdit } from "react-icons/fa";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { IoIosPeople } from "react-icons/io";
import { GoStop } from "react-icons/go";
// import { TbReportSearch } from "react-icons/tb";
import { CgCalendarDates } from "react-icons/cg";
import { Link } from "react-router-dom";

import { ACTIVE_MODULE } from "app/_constants/constant";

// permission
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { SetPermission } from "app/Components/SetPermission/Permissions";
import {
  allTrainingAssignersCount,
  getAllTrainingAssigners,
} from "app/_services/ehs/ehsTrainingServices";
import { isUserMM, isUserSO, isUserVTO } from "../IncidentManagement/Helper";
import { TRAINING_STATUS } from "./CONSTANTS";

const TrainingManagement = ({
  match: {
    params: { siteId },
  },
}) => {
  const [state, setState] = useState({
    trainingDue: 0,
  });

  useEffect(() => {
    // getAllTrainingAssigners().then((response) => {
    //   setState((prev) => ({
    //     ...prev, trainingDue: response.data?.filter(
    //       (d) => (d.trainingStatus === TRAINING_STATUS.due || d.trainingStatus === TRAINING_STATUS.overDue)
    //     )?.length || 0
    //   }));
    // }

    allTrainingAssignersCount().then((response) => {
      setState((prev) => ({
        ...prev,
        trainingDue: response?.data?.total || 0,
      }));
    });
  }, []);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          { name: "Training Management" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="manageBtnScreen">
        <Row>
          <SetPermission
            permission={"vto"}
            data={
              <Col className="my-2" lg={4}>
                <Link
                  to={
                    (siteId ? `/sites/${siteId}` : "") +
                    "/health-safety-and-environment/training-management/assign"
                  }
                  className="d-block btn manage-btn approvalActionBtn"
                  style={{ paddingTop: 16 }}
                >
                  <AiOutlineSchedule />
                  <span>Schedule Training</span>
                  <span className="tabText">{`(${state.trainingDue
                    ?.toString()
                    .padStart(3, "0")} Trainings Due)`}</span>
                </Link>
              </Col>
            }
          />
          <Col className="my-2" lg={4}>
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/training-management/status"
              }
              className="btn manage-btn"
              style={{ paddingTop: 16 }}
            >
              <HiOutlineDocumentReport />
              <span>Training Status</span>
            </Link>
          </Col>

          {isUserVTO() && (
            <Col className="my-2" lg={4}>
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  "/health-safety-and-environment/training-management/batches"
                }
                className="btn manage-btn"
                style={{ paddingTop: 16 }}
              >
                <IoIosPeople />
                <span>Training Batches</span>
              </Link>
            </Col>
          )}

          {(isUserSO() || isUserMM() || isUserVTO()) && (
            <Col className="my-2" lg={4}>
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  "/health-safety-and-environment/training-management/approval-actions"
                }
                className="btn manage-btn"
              >
                <GoStop /> My Approval Actions
              </Link>
            </Col>
          )}

          {(isUserSO() || isUserMM() || isUserVTO()) && (
            <Col className="my-2" lg={4}>
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  "/health-safety-and-environment/training-management/approval-history"
                }
                className="btn manage-btn"
              >
                <AiOutlineFileSearch />
                My Approval History
              </Link>
            </Col>
          )}
          <Col className="my-2" lg={4}>
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/training-management/calendar"
              }
              className="btn manage-btn"
            >
              <CgCalendarDates /> Calendar
            </Link>
          </Col>

          <Col className="my-2" lg={4}>
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/training-management/view-inactive-staff-training"
              }
              className="btn manage-btn"
            >
              <IoIosPeople /> InActive Staff
            </Link>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TrainingManagement;
